module.exports = __webpack_public_path__ + "static/media/01B.81913c73.png";